import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
  },
  wrapper: {
    height: '100%',
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    boxShadow: '0px 1px 0px #E5E5E5',
    boxSizing: 'border-box',
    marginBottom: '5px',
    minHeight: '48px',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      minHeight: 'auto',
      width: '100%'
    },
  },
  toolbarLeft: {
    display: 'flex',
    alignItems: 'center',
    minWidth: '140px',
    height: '100%',
    borderRight: '1px solid #E2EBF6',
    boxSizing: 'border-box',
    color: '#59758B',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      borderRight: 'hidden',
      paddingTop: '20px',
     
    },
  },
  toolbarTitle: {
    padding: '12px 30px',
    fontWeight: 'bold',
    fontSize: '18px',
    lineHeight: '24px',
    color: '#000000',
    [theme.breakpoints.down('sm')]: {
      fontSize: '16px',
      padding: '10px 20px',
      width: '100%',
      textAlign: 'center'
    },
  },
  toolbarFilter: {
    alignItems: 'center',
    display: 'flex',
    height: '100%',
  },
  formControl: {
    padding: '11px 30px 9px 0',
    minWidth: '90px',
    display: 'inline',
  },
  selectInput: {
    fontSize: '13px',
    color: '#717171',
    '&::before': {
      border: 'none',
    },
  },
  filterTitle: {
    padding: '12px 30px',
    minWidth: '51px',
    fontSize: '13px',
    whiteSpace: 'nowrap',
    [theme.breakpoints.down('sm')]: {
      padding: '10px 20px',
    },
  },
  selected: {
    backgroundColor: '#E2F5F8',
    fontWeight: 'bold',
  },
  customTabRoot: {
    padding: '8px 17px',
    borderBottom: '1px solid #E2EBF6',
    boxSizing: 'border-box',
    fontSize: '13px',
    minWidth: '50px!important',
  },
  toolbarSwitchers: {
    flexDirection: 'row',
    minWidth: '540px',
    borderRight: '1px solid #E2EBF6',
    [theme.breakpoints.down('sm')]: {
      minWidth: '300px',
      width: '100%',
      borderBottom: '1px solid #E2EBF6',
      borderTop: '1px solid #E2EBF6',
      borderRight: 'hidden',
      paddingTop: '20px',
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'center'
    },
  },
  buttonRoot: {
    fontSize: '13px',
    fontWeight: 'bold',
    padding: '7px 15px',
    marginLeft: '10px',
  },
  toolbarRight: {
    height: '100%',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    paddingRight: '30px',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center',
      borderBottom: '1px solid #E2EBF6',
      borderTop: '1px solid #E2EBF6',
      paddingTop: '20px',
      paddingBottom: '20px',
    },
  },
  tabsRoot: {
    flex: '1 1 auto',
    backgroundColor: theme.palette.background.paper,
    height: 'calc(100% - 24px)'
  },
  tabs: {
    flex: '0 1 220px',
    [theme.breakpoints.down('sm')]: {
      flex: '0 1 180px',
    },
  },
  customTabWrapper: {
    alignItems: 'center',
  },
  tabItemTitle: {
    fontWeight: 'bold',
    lineHeight: '18px',
    marginBottom: 12,
    color: 'inherit',
  },
  tabContentWrapper: {
    padding: '24px 20px 22px 20px',
    [theme.breakpoints.down('sm')]: {
      padding: '16px 10px 14px 10px',
    },
  },
  textColorInheritCustom: {
    opacity: 1,
    color: '#335267',
  },
  searchField: {
    width: '200px',
    '& .MuiInputBase-root': {
      border: '1px solid #BECEDA',
      borderRadius: '3px',
      '&:hover': {
        border: '1px solid #0E8BB4',
      },
      '&.Mui-focused': {
        border: '1px solid #0E8BB4',
        boxShadow: `0 0 3px 0.5px ${theme.baseUI.color}`,
      },
    },
    '& .MuiInputBase-input': {
      padding: '9px 5px 9px 10px',
      fontSize: '13px',
      lineHeight: '18px',
    },
    '& .MuiOutlinedInput-adornedEnd': {
      paddingRight: '10px',
    },
    '& .MuiIconButton-root': {
      padding: 0,
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: 0,
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      borderBottom: '1px solid #E2EBF6',
      borderTop: '1px solid #E2EBF6',
      paddingTop: '20px',
      paddingBottom: '20px',
      justifyContent: 'center',
      
    },
  },
}));

export default useStyles;
